import { ApiResponse, TicketManagerProject } from '@vision/ui/interfaces';

interface TicketManagerProjectResponseDto {
  created_at: string;
  has_pool: boolean;
  has_queue: boolean;
  id: string;
  name: string;
  ticket_ref_id_template: string;
  updated_at: string;
}

export function normalizeTicketManagerProject(dto: TicketManagerProjectResponseDto): TicketManagerProject {
  return {
    createdAt: dto.created_at,
    hasPool: dto.has_pool,
    hasQueue: dto.has_queue,
    id: dto.id,
    name: dto.name,
    ticketRefIdTemplate: dto.ticket_ref_id_template,
    updatedAt: dto.updated_at,
  };
}

export function normalizeTicketManagerProjectsResponse(
  response: ApiResponse<TicketManagerProjectResponseDto[]>,
): ApiResponse<TicketManagerProject[]> {
  return {
    ...response,
    data: response.data.map(normalizeTicketManagerProject),
  };
}

export function normalizeTicketManagerProjectResponse(
  response: ApiResponse<TicketManagerProjectResponseDto>,
): ApiResponse<TicketManagerProject> {
  return {
    ...response,
    data: normalizeTicketManagerProject(response.data),
  };
}
